export const WEB_URL = 'https://soundcloud.com';
export const MOBILE_URL = 'https://m.soundcloud.com';
export const API_BASE_URL = 'https://api-v2.soundcloud.com';
export const QUERY_MAX_LIMIT = 50;
export const LOCALES = [ 'de', 'en', 'es', 'fr', 'it', 'nl', 'pt_BR', 'pl', 'sv' ] as const;

export const USER_AGENT = 'Mozilla/5.0 (X11; Linux x86_64; rv:138.0) Gecko/20100101 Firefox/138.0';
export const SC_APP_VERSION = '1770022942';